import React from 'react';
import PropTypes from 'prop-types';

import styles from './troy.module.scss';

import NamedAvatar from '.';

import { NL, DE, DOMAIN_LANGUAGE } from '../../../constants/browser';

import { getPhoto } from '../../../utils/images';

const NAMES = { [NL]: 'Daniela Straube', [DE]: 'Philip Rürup' };
const DESCRIPTIONS = { [NL]: 'Directeur van troy', [DE]: 'TROY_DIRECTOR' };

const TroyNamedAvatar = ({
  nlMode,
  className,
  name,
  picture,
  descriptionKey,
  withoutDescription,
}) => (
  <NamedAvatar
    name={name || NAMES[DOMAIN_LANGUAGE] || NAMES[DE]}
    picture={picture || getPhoto(DOMAIN_LANGUAGE) || getPhoto(DE)}
    descriptionKey={
      descriptionKey || DESCRIPTIONS[DOMAIN_LANGUAGE] || DESCRIPTIONS[DE]
    }
    {...{ styles, className, withoutDescription }}
  />
);

TroyNamedAvatar.propTypes = {
  className: PropTypes.string,
};

export default TroyNamedAvatar;
